module.exports = __webpack_public_path__ + "static/media/08_avatar_male.5fdd23c2.png";